import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router/index.js';
import store from './store';
import './assets/scss/app.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSocialSharing from 'vue-social-sharing'
import titleMixin from './mixins/titleMixin'
import axios from "axios";

const fb = require('./firebaseConfig.js')

Vue.config.productionTip = false;
Vue.config.devtools = true;

import {
    faInfo,
    faInfoCircle,
    faPaperPlane,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faInfo,
    faInfoCircle,
    faPaperPlane,
)

import {
	faTwitter,
	faFacebook,
	faFacebookF,
	faLinkedin,
	faTelegram,
	faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'

library.add(
	faTwitter,
	faFacebook,
	faFacebookF,
	faLinkedin,
	faTelegram,
	faWhatsapp,
)

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueSocialSharing);

Vue.prototype.$analytics = fb.analytics;
Vue.prototype.$http = axios;

Vue.mixin(titleMixin)

// handle page reloads
let app
fb.auth().onAuthStateChanged(user => {
	if (!app) {
		new Vue({
			router,
			store,
			render: (h) => h(App),
			components: {
				App
			}
		}).$mount('#app');
		if(user)
			store.dispatch("fetchUser", user);
	}
})
